export default class Chatbot {
  constructor($chatbot) {
    // console.log('Chatbot', $element);
    this.$chatbot = $chatbot;
    this.$chatbotToggle = this.$chatbot.querySelector('.corey-toggle');
    this.$newsletterBreaker = document.querySelector('.newsletter-breaker__content');
    this.$footer = document.querySelector('.footer');

    const viewportHeight = window.innerHeight;

    // Calculate sticky-header change point
    const chatbotToggleRect = this.$chatbotToggle.getBoundingClientRect();
    if (this.$newsletterBreaker) {
      const footerElRect = this.$newsletterBreaker.getBoundingClientRect();
      this.chatbotChange =
        Math.round((footerElRect.top - viewportHeight) - chatbotToggleRect.height);
    }
  }

  deconstructor() {
    // Remove events
    document.removeEventListener('scroll', this.bindedScroll);
  }
}

if (document.getElementById('chatbot')) {
  // eslint-disable-next-line no-unused-vars
  const chatBot = new Chatbot(document.getElementById('chatbot'));
}
